import { ComponentProps } from '../layout-interfaces';

export const LineComponent = (props: ComponentProps) => {
  return <hr {...props.props.options} />;
};
